import { WebAPIClient } from "api";
import { ApiEndPoints } from "api/api-end-points";
import { APIResult } from "models/api-results";

import { ServiceType } from "models/setup/service-type";
import { Service } from "models/setup/job-category";
import { ServiceFilterParam } from "models/setup/job-category-filter-param";
import { BaseSearchParam } from "models/base-search-param";

import { VehicleModelImportParam } from 'models/setup/vehicle-model-import-param';
import { Manufacturer, VehicleModel } from 'models/setup/vehicle-model';
import { Tax } from "models/tax/tax";

export async function CreateServiceType(param: ServiceType): Promise<APIResult<ServiceType>> {
    return await WebAPIClient.postData<ServiceType>(ApiEndPoints.service_types_create, param);
}
export async function UpdateServiceType(param: ServiceType): Promise<APIResult<ServiceType>> {
    return await WebAPIClient.putData<ServiceType>(ApiEndPoints.service_types_update.replace("{id}", (param?.id ?? 0).toString()), param);
}
export async function GetServiceTypes(): Promise<APIResult<ServiceType[]>> {
    return await WebAPIClient.getData<ServiceType[]>(ApiEndPoints.service_types_search);
}



export async function CreateService(param: Service): Promise<APIResult<Service>> {
    return await WebAPIClient.postData<Service>(ApiEndPoints.service_create, param);
}
export async function UpdateService(param: Service): Promise<APIResult<Service>> {
    return await WebAPIClient.putData<Service>(ApiEndPoints.service_update.replace("{id}", (param?.id ?? 0).toString()), param);
}
export async function GetServices(param: ServiceFilterParam): Promise<APIResult<Service[]>> {
    const searchParams = new BaseSearchParam(param);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.service_search}${queryString}`;

    return await WebAPIClient.getData<Service[]>(apiUrl);
}

//Vehicle model import

export async function VehicleModelImport(param: VehicleModelImportParam): Promise<APIResult<VehicleModel[]>> {
    return await WebAPIClient.postData<VehicleModel[]>(ApiEndPoints.vehicle_model_import, param);
}
export async function GetMakes(): Promise<APIResult<Manufacturer[]>> {
    return await WebAPIClient.getData<Manufacturer[]>(ApiEndPoints.vehicle_makes_search);
}

export async function GetVehicleModels(): Promise<APIResult<VehicleModel[]>> {
    return await WebAPIClient.getData<VehicleModel[]>(ApiEndPoints.vehicle_model_search);
}

//Tax
export async function GetTaxes(): Promise<APIResult<Tax[]>> {
    return await WebAPIClient.getData<Tax[]>(ApiEndPoints.tax_search);
}